<template>
  <section class="underwriting-refer">
    <div class="table">
      <div class="tr">
        <span>Policy Type</span>
        <span>{{ getAllOptionName23('plan_type', quoteForm.plan_type) }}</span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span>{{ getAllOptionName23('area_of_travel', quoteForm.area_of_travel) }}</span>
      </div>
      <div
        v-if="quoteForm.class_type==1"
        class="tr">
        <span>Departure and Return Date</span>
        <span>{{ quoteForm.pcy_cmnt_dt }} - {{quoteForm.pcy_expry_dt}}</span>
      </div>

      <div class="tr">
        <span>Cover Type</span>
        <span>{{ getAllOptionName23('class_type', quoteForm.class_type) }}</span>
      </div>
      <div
        v-if="quoteForm.class_type==1&&![1,3,4].includes(quoteForm.plan_type)"
        class="tr">
        <span>No. of Traveller(s)</span>
        <span v-if="quoteForm.plan_type==2">{{ traveller }}</span>
        <span v-else>{{ getAllOptionName23('traveler_num', quoteForm.no_of_traveler) }}</span>
      </div>
      <!--      <div-->
      <!--        v-if="quoteForm.class_type==1"-->
      <!--        class="tr">-->
      <!--        <span>Area of Travel</span>-->
      <!--        <span>{{ getAllOptionName23('area_of_travel', quoteForm.area_of_travel) }}</span>-->
      <!--      </div>-->
      <div
        v-if="quoteForm.class_type!==1||[1,3,4].includes(quoteForm.plan_type)"
        class="tr">
        <span>No. of Traveller(s)</span>
        <span>{{ traveller }} </span>
      </div>
      <!--      <div-->
      <!--        v-if="quoteForm.class_type!==1"-->
      <!--        class="tr">-->
      <!--        <span>Number of Child</span>-->
      <!--        <span>{{ getAllOptionName23('child_num', quoteForm.no_of_child) }}</span>-->
      <!--      </div>-->
      <!--      <div class="tr">-->
      <!--        <span>Number of Child</span>-->
      <!--        <span>{{ getAllOptionName23('child_num', quoteForm.no_of_child) }}</span>-->
      <!--      </div>-->
    </div>

    <template v-if="benefitsList && benefitsList.length > 0">
      <h3>More Benefits</h3>
      <div class="benefits-list">
        <span
          v-for="(item, index) in benefitsList"
          :key="index">
          {{ item }}
        </span>
      </div>
    </template>
  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'

export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions23
    },
    benefitsList() {
      const { benefits = [] } = this.quoteForm
      if(!benefits) {
        return []
      }
      return benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName23('benefits', item)
        )
        return result
      }, [])
    },
    traveller(){
      const { class_type, no_of_traveler, no_of_adult, no_of_child, plan_type,no_of_senior } = this.quoteForm
      const signAdult = 'Adult(s)'
      const signSenior = 'Elderly'
      const signChild = 'Child(ren)'
      let child = no_of_child?`${no_of_child} ${signChild}`:''
      let senior = no_of_senior?`${no_of_senior} ${signSenior}  `:''
      let adult = no_of_adult?`${no_of_adult} ${signAdult} `:''
      let all_text = `${senior} ${adult} ${child}`
      return all_text
    },
  }
}
</script>
